import {
	ContentTypes,
	ContentTypesWithString,
	DataTypesWithString,
	Categories,
} from 'src/api/product'

export const renderOption = (option: number) => {
	let renderString: string

	switch (option) {
		case 1:
			renderString = '라이트'
			break
		case 2:
			renderString = '베이직'
			break
		case 3:
			renderString = '프로'
			break
		case 20:
			renderString = '라이선스'
			break
		default:
			renderString = ''
	}

	return renderString
}

export const maxUsageType = (option: number) => {
	let renderString: number

	switch (option) {
		case 1:
			renderString = 5
			break
		case 2:
			renderString = 100
			break
		case 3:
			renderString = 500
			break
		default:
			renderString = 0
	}
	return renderString
}
export const renderSourceType = (status) => {
	let renderString: string

	switch (status) {
		case 'work':
			renderString = '문학 라이선스'
			break
		case 'textbook':
			renderString = '교과서 라이선스'
			break
		case 'handout':
			renderString = '수업자료'
			break
		case 'workbook':
			renderString = '참고서 라이선스'
			break
		case 'aladinbook':
			renderString = '도서'
			break
		default:
			renderString = ''
	}

	return renderString
}

export const renderPriceLimit = (status) => {
	let renderString: string

	switch (status) {
		case 'lite':
			renderString = '라이트 (최대 5명까지 이용 가능)'
			break
		case 'basic':
			renderString = '베이직 (최대 100명까지 이용 가능)'
			break
		case 'pro':
			renderString = '프로 (최대 500명까지 이용 가능)'
			break
		case 'e-learning':
			renderString = '디지털 교재'
			break
		case 'e-teaching':
			renderString = '라이선스'
			break
		default:
			renderString = ''
	}

	return renderString
}
export const PLAN_LEARNING = 'e-learning'
export const PLAN_TEACHING = 'e-teaching'
export const renderPlanDescription = (plan) => {
	let renderString: string

	switch (plan) {
		case PLAN_LEARNING:
			renderString = '개인 이용 목적, 비상업적 이용'
			break
		case PLAN_TEACHING:
			renderString = '수업 이용 목적, 상업적 이용'
			break
		default:
			renderString = ''
			break
	}

	return renderString
}
export const renderPlanNewType = (plan) => {
	let renderString: string

	switch (plan) {
		case PLAN_LEARNING:
			renderString = '디지털 교재'
			break
		case PLAN_TEACHING:
			renderString = '라이선스'
			break
		default:
			renderString = ''
			break
	}

	return renderString
}

export const renderDataTypeWithComma = (data: Categories[]) => {
	if (!data) return null
	return data.map((item) => DataTypesWithString[item]).join(', ')
}

export const renderContentTypeWithComma = (data: ContentTypes[]) => {
	if (!data) return null
	return data.map((item) => ContentTypesWithString[item]).join(', ')
}
